// extracted by mini-css-extract-plugin
export var DentistSelector = "index-module--DentistSelector--uciUY";
export var go = "index-module--go--bXD3f";
export var heading = "index-module--heading--xJps+";
export var linkhover = "index-module--linkhover--Vr+6C";
export var selectcontainer = "index-module--selectcontainer--77bTA";
export var selectcontainererror = "index-module--selectcontainererror--7-vHh";